import { BANNER_DEFAULTS, B_03 } from "@stadium/shared/src/helpers/plasmic/static-slices";
import { type LinkWithLangType } from "@stadium/shared/src/constants/stores/routes";
import type { LinkRouteDefaults } from "@stadium/shared/src/components/link-with-lang";

import InteractiveFeatures from "./index.client";
import styles from "./main.module.scss";

export interface FeatureIcon {
  icon: string;
  iconAlt: string;
  text: string;
  video: string;
}

export interface B03Props {
  eyebrowText?: string;
  heading?: string;
  features?: FeatureIcon[];
  ctaText?: string;
  ctaLinkType?: string;
  ctaOpenInNewTab?: boolean;
  ctaOtherUrl?: string;
  ctaCategorySlug?: string;
  className?: string;
  linkRouteDefaults?: LinkRouteDefaults;
}

const emptyArray = [];

const B03 = ({
  eyebrowText = BANNER_DEFAULTS[B_03].eyebrowText,
  heading = BANNER_DEFAULTS[B_03].heading,
  features = BANNER_DEFAULTS[B_03].features,
  ctaText = BANNER_DEFAULTS[B_03].ctaText,
  ctaLinkType = BANNER_DEFAULTS[B_03].ctaLinkType,
  ctaOpenInNewTab = false,
  ctaOtherUrl,
  ctaCategorySlug,
  className,
  linkRouteDefaults,
}: Readonly<B03Props>) => {
  const bannerFeatures =
    features?.map((feature, index) => ({
      id: `feature-${index + 1}`,
      ...feature,
    })) || emptyArray;

  return (
    <section className={`${styles.section} ${className || ""}`}>
      <div className={styles.b03container}>
        <div className={styles.contentWrapper}>
          <div className={styles.flexContainer}>
            <InteractiveFeatures
              bannerFeatures={bannerFeatures}
              ctaText={ctaText}
              ctaLinkType={ctaLinkType as LinkWithLangType}
              ctaOpenInNewTab={ctaOpenInNewTab}
              ctaOtherUrl={ctaOtherUrl}
              ctaCategorySlug={ctaCategorySlug}
              linkRouteDefaults={linkRouteDefaults}
            >
              {/* Eyebrow Text */}
              {eyebrowText && <p className={styles.eyebrowText}>{eyebrowText}</p>}

              {/* Heading */}
              {heading && <h2 className={styles.heading}>{heading}</h2>}
            </InteractiveFeatures>
          </div>
        </div>
      </div>
    </section>
  );
};
export default B03;
